import _isEmpty from 'lodash/isEmpty';
import _cloneDeep from 'lodash/cloneDeep';

export const isEmpty = (entity: any) => _isEmpty(entity);
export const cloneDeep = (entity: any) => _cloneDeep(entity);
export const formatCurrency = (number: number) => Intl.NumberFormat('en-US').format(number) + ' đ';
export const formatNumber = (number: number) => Intl.NumberFormat('en-US').format(number);